 const PasswordConfig = Object.freeze({
    passwordMinCharacters : 8

});

export default PasswordConfig;